import { render } from "./Languages.vue?vue&type=template&id=16df8d05"
import script from "./Languages.vue?vue&type=script&lang=js"
export * from "./Languages.vue?vue&type=script&lang=js"

import "./Languages.vue?vue&type=style&index=0&id=16df8d05&lang=css"
script.render = render

export default script